import { FormGroup, FormParagraph } from '@ksyos/design-system';
import { SendSleepRecorderOption, SleepRecorderType } from '@common/validation/customControls/somnology';
import { getSelectedLanguage } from '@frontend/translate';

interface ISleepRecorderDetails {
    distributionMethod: SendSleepRecorderOption | null;
    patientHasSmartphone: boolean | null;
    sleepRecorderType: SleepRecorderType | null;
}

export function SleepRecorderDetails(props: ISleepRecorderDetails) {
    return (
        <>
            {typeof props.patientHasSmartphone === 'boolean' && (
                <FormGroup label="Patiënt beschikt over een smartphone">
                    <FormParagraph>
                        {props.patientHasSmartphone
                            ? getSelectedLanguage().common.yes
                            : getSelectedLanguage().common.no}
                    </FormParagraph>
                </FormGroup>
            )}

            {props.distributionMethod && (
                <FormGroup label="Slaaprecorder verzenden">
                    <FormParagraph>{getSelectedLanguage().osas[props.distributionMethod]}</FormParagraph>
                </FormGroup>
            )}

            {props.sleepRecorderType && (
                <FormGroup label="Type slaaprecorder">
                    <FormParagraph>{getSleepRecorderType()}</FormParagraph>
                </FormGroup>
            )}
        </>
    );

    function getSleepRecorderType() {
        switch (props.sleepRecorderType) {
            case SleepRecorderType.nightowl:
                return props.distributionMethod === SendSleepRecorderOption.sendByKsyos
                    ? 'NightOwl Mini'
                    : SleepRecorderType.nightowlReusable;
            case SleepRecorderType.watchpat:
                return 'WatchPAT';
            default:
                return props.sleepRecorderType;
        }
    }
}
